/* eslint no-console: 0 */

<template>
  <div
    class="mini-cart"
    :class="{open: isOpen}"
  >
    <div class="mini-cart-wrapper">
      <div class="mini-cart-inner">
        <span id="mini-cart-message">
          {{ message }}
        </span>

        <div class="mini-cart__header">
          <div class="mini-cart__header-copy">
            <span class="mini-cart__eyebrow">Ваш заказ</span>
            <span class="h3 mini-cart__heading">
              Корзина
            </span>
          </div>

          <button
            class="mini-cart__close"
            type="button"
            @click="toggleOpen"
          >
            <svg viewBox="0 0 16 16" aria-hidden="true">
              <path d="M2 2l12 12M14 2L2 14" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5" />
            </svg>
            <span class="uk-shell-sr-only">Закрыть</span>
          </button>
        </div>

        <div
          v-if="!isEmpty()"
          class="mini-cart__content"
        >
          <transition-group
            name="fade"
            tag="ul"
            class="mini-cart__list"
          >
            <line-item
              v-for="lineItem in lineItems"
              :id="lineItem.id"
              :key="lineItem.id"
              :product="lineItem.product"
              :selected-variant="lineItem.productVariant"
              @destroy-line-item="destroyLineItem"
            />
          </transition-group>

          <div class="mini-cart__nudge">
            <div class="mini-cart__nudge-icon" aria-hidden="true">
              <svg viewBox="0 0 20 20">
                <path d="M10 3.5a6.5 6.5 0 1 1 0 13a6.5 6.5 0 0 1 0-13Zm0 3.25v3.5m0 2.5h.01" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
              </svg>
            </div>

            <div>
              <div class="mini-cart__nudge-text">
                Нужна помощь с размером или посадкой? Подскажем перед оформлением.
              </div>
              <a class="mini-cart__nudge-link" href="/contacts">
                Связаться с консультантом
              </a>
            </div>
          </div>

          <div class="mini-cart__footer">
            <div class="mini-cart__total">
              <span>Подитог</span>
              <span class="ammount">{{ price.lineItemsPrice }} ₽</span>
            </div>

            <div class="mini-cart__delivery-note">
              Бесплатная доставка от 15 000 ₽ после выкупа
            </div>

            <div class="mini-cart__buttons">
              <a
                class="uk-button uk-button-primary uk-button-lg mini-cart__checkout"
                href="/orders/new"
              >Оформить заказ</a>

              <a
                class="mini-cart__continue"
                href="/"
                @click="toggleOpen"
              >Продолжить покупки</a>
            </div>

            <div class="mini-cart__reassurance">
              <div class="mini-cart__reassurance-item">Примерка перед оплатой</div>
              <div class="mini-cart__reassurance-item">Быстрая доставка</div>
              <div class="mini-cart__reassurance-item">Поддержка по размеру</div>
            </div>
          </div>
        </div>

        <div
          v-else
          class="mini-cart__empty"
        >
          <div class="mini-cart__empty-icon" aria-hidden="true">
            <svg viewBox="0 0 28 28">
              <path d="M3 3h3.5l4 14h11l3.5-10H8.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6" />
              <circle cx="12.5" cy="22.5" r="1.5" fill="currentColor" />
              <circle cx="20.5" cy="22.5" r="1.5" fill="currentColor" />
            </svg>
          </div>
          <span class="mini-cart__heading mini-cart__heading--empty">Корзина пуста</span>
          <span class="mini-cart__empty-text">Добавьте товар из каталога, и он появится здесь.</span>
          <a class="mini-cart__empty-cta" href="/" @click="toggleOpen">Перейти в каталог</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    lineItems:  {
      type: Array,
      default () {
        return [];
      }
    },
    price: {
      type: Object,
      default () {
        return {
          deliveryPrice: 0,
          discount: 0,
          lineItemsPrice: 0,
          totalPrice: 0
        };
      }
    }
  },
  emits: ['toggle-sidemenu', 'destroy-line-item'],

  data: () => {
    return {
      message: ''
    };
  },

  methods: {
    toggleOpen: function() { this.$emit('toggle-sidemenu', 'cart'); },

    destroyLineItem: function(id) { this.$emit('destroy-line-item', id); },

    isEmpty: function() { return this.lineItems.length == 0; },
  }
};
</script>
